<template>
    <b-form-checkbox
      :id="id"
      :name="name"
      :checked="isChecked" 
      :size="size" 
      :disabled="disabled"
      :inline="inline"
      :indeterminate="indeterminate"
      @change.native="change"
    >
      <slot></slot>
      {{text}}
    </b-form-checkbox>
</template>


<script>
export default{
  model: {
    prop: "modelValue",
    event: "change"
  },

  props: {
    id: {
      type: String,
      default: null,
      required: false
    },

    name: {
      type: String,
      default: null,
      required: false
    },

    value: {
      type: String,
      default: null,
      required: false
    },

    modelValue: {
      type: [Array,Boolean,String],
      default: null,
      required: false
    },

    text: {
      type: String,
      default: null,
      required: false
    },

    size: {
      type: String,
      default: "md",
      required: false
    },

    indeterminate: {
      type: Boolean,
      default: false,
      required: false
    },

    trueValue: {
      type: [Boolean,String],
      default: true,
      required: false
    },

    falseValue: {
      type: [Boolean,String],
      default: false,
      required: false
    },

    disabled: {
      type: Boolean,
      default: false,
      required: false
    },

    inline: {
      type: Boolean,
      default: false,
      required: false
    },
  },

  computed: {
    isChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value)
      } else {
        return this.modelValue  === this.trueValue
      }      
    }
  },

  methods: {
    change(event) {
      let isChecked = event.target.checked
     
      if (this.modelValue instanceof Array) { 
        let newValue = this.modelValue

        if (isChecked) {
          newValue.push(this.value)
        } else {
          newValue.splice(newValue.indexOf(this.value), 1) 
        }
        console.log(newValue)
        this.$emit('change',  newValue)
        
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue)
      }
    }
  }
};
</script>